import React from 'react';
import { motion } from 'framer-motion';

const SplitText = ({ children, className, delay = 0 }) => {
    const text = children.toString();
    const characters = text.split("");

    return (
        <span className={`${className} inline-block`}>
            {characters.map((char, index) => (
                <motion.span
                    key={index}
                    initial={{ opacity: 0, y: "100%" }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                        duration: 0.5,
                        delay: delay + index * 0.02,
                        ease: [0.33, 1, 0.68, 1] // Cubic bezier for smooth entry
                    }}
                    className="inline-block origin-bottom"
                >
                    {char === " " ? "\u00A0" : char}
                </motion.span>
            ))}
        </span>
    );
};

export default SplitText;
